function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M88.4,88.8h-59V74h59V88.8z M-0.1,29.8h88.5v14.8H-0.1v73.8H118V0.3H-0.1V29.8z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st0",
  points: "162.2,88.8 162.2,0.3 132.7,0.3 132.7,118.3 250.8,118.3 250.8,88.8 "
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M221.2,221.6h-59v-14.8h59V221.6z M132.7,133.1v29.5h88.5v14.8h-88.5v73.8h118v-118h-118V133.1z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st0",
  points: "73.7,251.1 73.7,162.6 88.4,162.6 88.4,251.1 117.9,251.1 117.9,133.1 -0.1,133.1 -0.1,251.1  29.4,251.1 29.4,162.6 44.2,162.6 44.2,251.1 "
});

var SvgAlmaMediaLogo = function SvgAlmaMediaLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.7 251.2",
    style: {
      enableBackground: "new 0 0 250.7 251.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAlmaMediaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alma_media_logo.250be5a4.svg";
export { ForwardRef as ReactComponent };